import type { HelpFile } from '../../types/help'
import { EffectiveAccessByIdentityTestIds } from '../../../testids/EffectiveAccessByIdentityTestIds'

export const effectiveAccessByIdentityHelp: HelpFile = {
  docPage: '/docs/analytics/effective-access',
  texts: {
    [EffectiveAccessByIdentityTestIds.effectiveAccessByIdentityPage]:
      'Übersicht aller Identitäten mit ihrer aktuellen effektiven Berechtigung — zeigt, wer auf welchen Zielsystemen Zugriff hat.',
    [EffectiveAccessByIdentityTestIds.colActions]: null,
    [EffectiveAccessByIdentityTestIds.colIdentity]: null,
    [EffectiveAccessByIdentityTestIds.colParty]:
      'Partei, der diese Identität gehört (Person, Organisation oder KI-Agent).',
    [EffectiveAccessByIdentityTestIds.colStatus]: null,
    [EffectiveAccessByIdentityTestIds.colType]:
      'Typ der Identität — Mitarbeiter, externer Mitarbeiter, technisches Konto usw.',
  },
}
